import options from './virtualGlycolBuffer.component';


export default {
    selector: "dtEmulatorVirtualGlycolBuffer",
    options
}